import { render, staticRenderFns } from "./registrationForm.vue?vue&type=template&id=29441e28&scoped=true"
import script from "./registrationForm.vue?vue&type=script&lang=js"
export * from "./registrationForm.vue?vue&type=script&lang=js"
import style0 from "./registrationForm.vue?vue&type=style&index=0&id=29441e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29441e28",
  null
  
)

export default component.exports